import { render, staticRenderFns } from "./DarkNavbar.vue?vue&type=template&id=c882aaca"
import script from "./DarkNavbar.vue?vue&type=script&lang=js"
export * from "./DarkNavbar.vue?vue&type=script&lang=js"
import style0 from "./DarkNavbar.vue?vue&type=style&index=0&id=c882aaca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports